import { render, staticRenderFns } from "./IntegrationCustomDomain.vue?vue&type=template&id=15e26e8c&scoped=true&"
import script from "./IntegrationCustomDomain.vue?vue&type=script&lang=js&"
export * from "./IntegrationCustomDomain.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationCustomDomain.vue?vue&type=style&index=0&id=15e26e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e26e8c",
  null
  
)

export default component.exports